import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const AdoptionCountrySchema = z.object({ destinationCountryCode: z.string() });

const AdoptionGroupSchema = z.object({
  key: z.string(),
  markup: z.number(),
  markupStrategy: z.string(),
  includeInPrice: z.array(z.string()),
  excludeInCheckout: z.array(z.string()),
  coverWithMarkup: z.array(z.string()),
  isMultiCountry: z.boolean(),
  countries: z.array(AdoptionCountrySchema),
});

export const previewShopifyMarketAdoption = {
  name: "previewShopifyMarketAdoption" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    totalShopifyMarkets: z.number(),
    homeCountryCode: z.string(),
    groups: z.array(AdoptionGroupSchema),
    alreadyAdoptedCount: z.number(),
    coveredCountryCodes: z.array(z.string()),
    skippedHomeCountry: z.array(
      z.object({ handle: z.string(), countryCodes: z.array(z.string()) }),
    ),
  }),
};
